/** German (default) */
const de = {
  common: {
    save: "Speichern",
    saving: "Speichern…",
    saved: "Gespeichert",
    cancel: "Abbrechen",
    close: "Schließen",
    back: "Zurück",
    backToDashboard: "Zurück zum Dashboard",
    loading: "Laden…",
    error: "Fehler",
    all: "Alle",
    yes: "Ja",
    no: "Nein",
    user: "Benutzer",
    admin: "Admin",
    enterpriseTier: "Enterprise Tier",
    globalReputation: "ReviewLytics",
    brandSubtitle: "Review Analytics",
    preferencesSaved: "Einstellungen erfolgreich gespeichert",
    unsavedChanges: "Ungespeicherte Änderungen. Bitte speichern Sie Ihre Aktualisierungen.",
    allSaved: "Alle Einstellungen sind gespeichert und aktuell.",
    mainNav: "Hauptnavigation",
    documentation: "Dokumentation",
    support: "Support",
    settings: "Einstellungen",
    search: "Suche",
    open: "Öffnen",
    active: "Aktiv",
    enabled: "Aktiviert",
    disabled: "Deaktiviert",
    systemStatusOptimal: "Systemstatus: Optimal",
    storageUsage: "Speichernutzung",
    yourWorkspace: "Ihr Arbeitsbereich",
  },
  nav: {
    dashboard: "Dashboard",
    billing: "Pläne & Abrechnung",
    reviewHub: "Review Hub",
    deletionCases: "Löschfälle",
    emailAlerts: "E-Mail-Benachrichtigungen",
    platforms: "Plattformen",
    payment: "Zahlung",
    settings: "Einstellungen",
    support: "Support",
    documentation: "Dokumentation",
    users: "Benutzer",
    reviews: "Bewertungen",
    newCase: "Neuer Fall",
    adminDeletionCases: "Löschfälle",
    premiumPerks: "Premium-Vorteile",
  },
  perks: {
    eyebrow: "Premium-Vorteile",
    title: "Exklusive Rabatte",
    subtitle:
      "Ihre Professional-Mitgliedschaft sichert Ihnen Vorzugskonditionen auf digitale Services unseres Partnerstudios.",
    heroTitleNamed: "Sie sind Professional-Mitglied, {{name}}",
    heroTitle: "Sie sind Professional-Mitglied",
    heroDesc:
      "Als Premium-Abonnent erhalten Sie 20% Rabatt auf alle folgenden Services — von Ihrer Business-Website bis zum maßgeschneiderten CRM.",
    heroBadge: "Professional",
    discountBadge: "−20%",
    websiteDevTitle: "Website-Entwicklung",
    websiteDevDesc:
      "Eine schnelle, moderne Business-Website — designt, entwickelt und live für Ihre Marke.",
    crmDevTitle: "CRM-Entwicklung",
    crmDevDesc:
      "Ein individuelles CRM für Ihre Abläufe: Leads, Kunden, Pipelines und Auswertungen.",
    automationTitle: "Workflow-Automatisierung",
    automationDesc:
      "Automatisieren Sie Routineaufgaben — Integrationen, Synchronisationen und Benachrichtigungen.",
    designTitle: "UI/UX-Design",
    designDesc:
      "Hochwertige Interfaces und markenkonsistente Designsysteme für Ihre digitalen Produkte.",
    claimCta: "Angebot anfordern",
    note: "Zum Einlösen kontaktieren Sie unser Team über den Support und erwähnen Ihre Professional-Mitgliedschaft — die 20% werden auf Ihr Angebot angerechnet.",
    lockedTitle: "Exklusive Rabatte für Professional-Mitglieder",
    lockedDesc:
      "Upgraden Sie auf Professional und sichern Sie sich 20% Rabatt auf Website-Entwicklung, CRM-Entwicklung und mehr.",
    lockedCta: "Pläne ansehen",
  },
  jamedaConnect: {
    title: "Jameda verbinden",
    subtitle:
      "Verknüpfen Sie Ihr Jameda-Profil mit Ihrem persönlichen API-Schlüssel — Ihre Patientenbewertungen werden automatisch synchronisiert.",
    guideTitle: "Wo finde ich meine Zugangsdaten?",
    step1Title: "Bei Jameda anmelden",
    step1Detail:
      "Melden Sie sich auf jameda.de mit Ihrem Praxiskonto an und öffnen Sie Ihren Verwaltungsbereich.",
    step2Title: "API-Einstellungen öffnen",
    step2Detail:
      "Gehen Sie im Verwaltungsmenü zu „Einstellungen“ → „Schnittstellen & API“.",
    step3Title: "API-Schlüssel generieren",
    step3Detail:
      "Klicken Sie auf „Neuen API-Schlüssel generieren“ und kopieren Sie den Schlüssel. Behandeln Sie ihn wie ein Passwort — nicht weitergeben.",
    step4Title: "Business-ID kopieren",
    step4Detail:
      "Sie finden sie direkt neben dem API-Schlüssel — oder in Ihrer Profil-URL, z. B. jameda.de/profil/12345678 → Ihre ID ist 12345678.",
    helpNote: "Sie finden den API-Bereich in Ihrem Jameda-Konto nicht?",
    helpLink: "Unser Support-Team hilft Ihnen gerne",
    businessIdLabel: "Jameda Business-ID",
    businessIdPlaceholder: "z. B. 12345678",
    businessIdHint: "Die Nummer aus Ihrer Jameda-Profil-URL oder den API-Einstellungen.",
    apiKeyLabel: "Jameda API-Schlüssel",
    apiKeyPlaceholder: "API-Schlüssel einfügen",
    apiKeyHint: "Wird in Ihrem Jameda-Konto unter Schnittstellen & API generiert.",
    showKey: "API-Schlüssel anzeigen",
    hideKey: "API-Schlüssel verbergen",
    connectCta: "Prüfen & verbinden",
    connecting: "Zugangsdaten werden geprüft…",
    errorRequired: "Bitte geben Sie Ihre Business-ID und Ihren API-Schlüssel ein.",
    errorGeneric:
      "Verbindung fehlgeschlagen. Bitte prüfen Sie Business-ID und API-Schlüssel und versuchen Sie es erneut.",
    errorInvalidCredentials:
      "Jameda hat diese Zugangsdaten nicht akzeptiert. Bitte prüfen Sie Business-ID und API-Schlüssel — Schritt 3 und 4 in der Anleitung zeigen, wo Sie sie finden.",
    errorNotFound:
      "Zu dieser Business-ID wurde kein Jameda-Profil gefunden. Bitte prüfen Sie die Nummer (Schritt 4 in der Anleitung).",
    errorUnreachable:
      "Jameda ist derzeit nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.",
    securityNote:
      "Ihr API-Schlüssel wird sicher gespeichert und nur zur Synchronisation Ihrer Bewertungen verwendet. Sie können die Verbindung jederzeit trennen.",
  },
  sidebar: {
    loggingOut: "Abmelden…",
    logout: "Abmelden",
    backToAdmin: "Zurück zum Admin",
  },
  auth: {
    login: "Anmelden",
    loginTitle: "Willkommen zurück",
    loginSubtitle: "Melden Sie sich an, um Ihr Reputations-Dashboard zu öffnen.",
    email: "E-Mail",
    password: "Passwort",
    rememberMe: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    noAccount: "Noch kein Konto?",
    signUp: "Registrieren",
    signingIn: "Anmelden…",
    emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
    emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    passwordRequired: "Bitte geben Sie Ihr Passwort ein.",
    loginFailed: "Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Zugangsdaten.",
    twoFactorTitle: "Prüfen Sie Ihre E-Mails",
    twoFactorSubtitle: "Zu Ihrer Sicherheit haben wir einen 6-stelligen Code an {{email}} gesendet. Geben Sie ihn unten ein, um die Anmeldung abzuschließen.",
    twoFactorCodeLabel: "Bestätigungscode",
    twoFactorVerify: "Bestätigen & anmelden",
    twoFactorVerifying: "Wird geprüft…",
    twoFactorResend: "Code erneut senden",
    twoFactorResendIn: "Erneut senden in {{seconds}}s",
    twoFactorBack: "Zurück zur Anmeldung",
    twoFactorExpired: "Die Anmeldesitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    twoFactorInvalidCode: "Ungültiger oder abgelaufener Code. Bitte erneut versuchen.",
    twoFactorDevMode: "Entwicklungsmodus: Es wurde keine E-Mail versendet. Den 6-stelligen Code finden Sie in der Server-Konsole.",
    signup: "Registrieren",
    forgotPasswordTitle: "Passwort vergessen",
    forgotPasswordSubtitle: "Wir senden Ihnen einen Link zum Zurücksetzen.",
    sendResetLink: "Link senden",
    backToLogin: "Zurück zur Anmeldung",
    notFoundTitle: "Seite nicht gefunden",
    notFoundBody: "Die angeforderte Seite existiert nicht.",
    goHome: "Zur Startseite",
    consentPrefix: "Mit der Nutzung stimmen Sie unseren",
    resetLinkSending: "Wird gesendet…",
    resetLinkSent: "Zurücksetzungslink senden",
    emailSentTitle: "E-Mail gesendet",
    emailSentBody:
      "Wenn ein Konto mit dieser E-Mail-Adresse existiert, haben wir Ihnen einen Link zum Zurücksetzen des Passworts gesendet.",
    resetTitle: "Neues Passwort festlegen",
    resetSubtitle: "Wählen Sie ein neues Passwort für Ihr Konto.",
    resetNewPassword: "Neues Passwort",
    resetConfirmPassword: "Passwort bestätigen",
    resetSubmit: "Neues Passwort speichern",
    resetSaving: "Wird gespeichert…",
    resetMismatch: "Die Passwörter stimmen nicht überein.",
    resetTooShort: "Das Passwort muss mindestens 8 Zeichen lang sein.",
    resetSuccessTitle: "Passwort geändert",
    resetSuccessBody: "Ihr Passwort wurde geändert. Sie können sich jetzt damit anmelden.",
    resetInvalidToken:
      "Dieser Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
    resetGenericError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    goToLogin: "Zur Anmeldung",
    signupStepPersonal: "Persönliche Daten",
    signupStepCompany: "Unternehmensdaten",
    fullName: "Vollständiger Name",
    companyName: "Unternehmensname",
    industry: "Branche / CEO",
    businessEmail: "Geschäfts-E-Mail",
    businessAddress: "Geschäftsadresse",
    next: "Weiter",
    back: "Zurück",
    createAccount: "Konto erstellen",
    haveAccount: "Bereits ein Konto?",
    registerFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    registerCheckDetails: "Registrierung fehlgeschlagen. Bitte prüfen Sie Ihre Angaben.",
    fullNameRequired: "Bitte geben Sie den vollständigen Namen ein.",
    companyNameRequired: "Bitte geben Sie den Unternehmensnamen ein.",
    businessEmailRequired: "Bitte geben Sie die Geschäfts-E-Mail ein.",
    businessAddressRequired: "Bitte geben Sie die Geschäftsadresse ein.",
    industryRequired: "Bitte geben Sie die Branche ein.",
    passwordMinLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
  },
  settings: {
    title: "Einstellungen",
    subtitle:
      "Konfigurieren Sie Arbeitsbereich, Benachrichtigungen und Sicherheit für einen professionellen Betrieb.",
    general: "Allgemeine Einstellungen",
    language: "Sprache",
    languageEn: "Englisch (USA)",
    languageDe: "Deutsch (DE)",
    timezone: "Zeitzone",
    reviewsInbox: "Bewertungen & Posteingang",
    autoSync: "Bewertungen beim Login automatisch synchronisieren",
    autoSyncHint:
      "Neueste Bewertungen und Audit-Daten beim Start der Sitzung automatisch abrufen.",
    emailNotifications: "E-Mail-Benachrichtigungen",
    emailNotificationsHint:
      "Tägliche Zusammenfassungen und kritische Hinweise per E-Mail erhalten.",
    showResolved: "Erledigte Bewertungen im Posteingang anzeigen",
    showResolvedHint:
      "Archivierte Bewertungen in der Hauptansicht sichtbar lassen.",
    accountSecurity: "Konto & Sicherheit",
    password: "Passwort",
    passwordLastChanged: "Zuletzt geändert vor 4 Monaten",
    changePassword: "Passwort ändern",
    twoFactor: "Zwei-Faktor-Authentifizierung",
    twoFactorHint: "Erhöhte Sicherheit per E-Mail-Code bei der Anmeldung",
    twoFactorEnable: "Aktivieren",
    twoFactorDisable: "Deaktivieren",
    twoFactorSending: "Code wird gesendet…",
    twoFactorEnterCode: "Geben Sie den 6-stelligen Code ein, den wir an {{email}} gesendet haben.",
    twoFactorConfirm: "Bestätigen",
    twoFactorCodeInvalid: "Ungültiger oder abgelaufener Code. Bitte erneut versuchen.",
    twoFactorPasswordPrompt: "Geben Sie Ihr Passwort ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
    twoFactorPasswordInvalid: "Falsches Passwort.",
    twoFactorError: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    twoFactorDevMode: "Entwicklungsmodus: Es wurde keine E-Mail versendet — der Code wurde in der Server-Konsole ausgegeben.",
    twoFactorEmailFailed: "Der Bestätigungscode konnte nicht per E-Mail gesendet werden. Bitte prüfen Sie die E-Mail-Konfiguration (SMTP) und versuchen Sie es erneut.",
    twoFactorEmailNotConfigured: "Der E-Mail-Versand ist noch nicht eingerichtet. Bitte hinterlegen Sie SMTP-Zugangsdaten, bevor Sie die Zwei-Faktor-Authentifizierung aktivieren.",
    enterpriseNoticeTitle: "Enterprise-Sicherheitshinweis",
    enterpriseNoticeBody:
      "Alle Einstellungsdaten werden Ende-zu-Ende verschlüsselt. Team-Benachrichtigungen werden zu Audit-Zwecken protokolliert.",
    downloadAuditLog: "Audit-Protokoll herunterladen",
    teamAccessPolicy: "Team-Zugriffsrichtlinie",
    saveSettings: "Einstellungen speichern",
    saveError: "Ihre Einstellungen konnten nicht gespeichert werden. Bitte erneut versuchen.",
    restartOnboarding: "Onboarding neu starten",
    supportResources: "Support-Ressourcen",
    apiDocs: "API-Dokumentation",
    helpCenter: "Hilfe-Center",
    trustSecurity: "Vertrauen & Sicherheit",
  },
  emailAlerts: {
    title: "E-Mail-Benachrichtigungen",
    subtitle:
      "Legen Sie fest, wann Ihr Team Reputations-Benachrichtigungen erhält.",
    negativeReview: "Hinweis bei negativer Bewertung",
    negativeReviewHint: "Sofortige E-Mail bei 1–3-Sterne-Bewertungen.",
    unreplied: "Erinnerung bei unbeantworteten Bewertungen",
    unrepliedHint: "Tägliche Erinnerung nach 24 Stunden ohne Antwort.",
    deletionUpdates: "Updates zu Löschfällen",
    deletionUpdatesHint:
      "Benachrichtigung bei Statusänderungen (eingereicht, in Bearbeitung, abgeschlossen).",
    ratingDrop: "Hinweis bei Rating-Rückgang",
    ratingDropHint: "Warnung bei deutlichem Rückgang der Durchschnittsbewertung.",
    weeklyDigest: "Wöchentliche Reputations-Zusammenfassung",
    weeklyDigestHint:
      "Zusammenfassung von Bewertungen, Antworten und Fällen jeden Montag.",
    savePreferences: "Benachrichtigungen speichern",
    negativeReviewHintDynamic:
      "Sofortige E-Mail bei Bewertungen mit {{threshold}} Sternen oder weniger.",
    thresholdLabel: "Alarm-Schwellenwert",
    thresholdOption: "{{count}}★ oder weniger",
    allActivity: "Alle Bewertungsaktivitäten",
    allActivityHint: "E-Mail bei jeder neuen oder aktualisierten Bewertung, unabhängig von der Sternezahl.",
    ticketReply: "Support-Antworten",
    ticketReplyHint: "E-Mail, wenn unser Team auf eines Ihrer Support-Tickets antwortet.",
    recipientNote:
      "Benachrichtigungen werden an Ihre registrierte Firmen-E-Mail gesendet: {{email}}",
    loadError: "Ihre Benachrichtigungseinstellungen konnten nicht geladen werden. Bitte erneut versuchen.",
    saveError: "Ihre Benachrichtigungseinstellungen konnten nicht gespeichert werden. Bitte erneut versuchen.",
  },
  adminEmailAlertsReal: {
    newCase: "Neuer Löschfall",
    newCaseHint: "E-Mail, wenn ein Kunde einen neuen Löschfall einreicht.",
    newTicket: "Neues Support-Ticket",
    newTicketHint: "E-Mail, wenn ein Kunde ein neues Support-Ticket eröffnet.",
    deliveryTitle: "Zustellung & Test",
    deliveryTransport: "Aktueller Transport: {{transport}}",
    deliveryRecipient: "Test-E-Mails gehen an Ihre Benachrichtigungsadresse: {{email}}",
    deliveryDevHint:
      "Keine SMTP-Zugangsdaten gesetzt — E-Mails erscheinen in der Django-Konsole. Für Live-Zustellung EMAIL_HOST, EMAIL_HOST_USER und EMAIL_HOST_PASSWORD in Backend/.env hinterlegen.",
    previewButton: "E-Mail-Vorschau",
    previewTitle: "E-Mail-Vorschau",
    testButton: "Test-E-Mail senden",
    sendingTest: "Wird gesendet…",
    testSent: "Test-E-Mail an {{email}} gesendet",
    testError: "Test-E-Mail konnte nicht gesendet werden. Server-Logs und E-Mail-Einstellungen prüfen.",
  },
  home: {
    overview: "Reputations-Übersicht",
    welcome: "Willkommen in Ihrem Reputations-Arbeitsbereich",
    welcomeHint:
      "Überwachen Sie Bewertungen, bearbeiten Sie kritische Fälle und schützen Sie Ihre Marke.",
    accountStatus: "Kontostatus",
    quickActions: "Schnellaktionen",
    needsReply: "Antwort erforderlich",
    needsReplyDesc: "Bewertungen beantworten, die auf Ihre Antwort warten.",
    criticalReviews: "Kritische Bewertungen",
    criticalReviewsDesc: "1–3-Sterne-Bewertungen mit Einfluss auf Ihr Rating.",
    deletionCases: "Löschfälle",
    deletionCasesDesc: "Rechtliche Entfernungsanträge und Fortschritt verfolgen.",
    connectPlatform: "Plattform verbinden",
    connectPlatformDesc: "Google Business oder weitere Quellen verknüpfen.",
    activeCases: "Aktive Fälle",
    connectProfile: "Profil verbinden",
    connectProfileHint:
      "Verbinden Sie Google Business, um Bewertungen und Kennzahlen zu sehen.",
    goToPlatforms: "Zu Plattformen",
    dashboardTitle: "Dashboard",
    greeting: "Willkommen zurück, {{name}}",
    overviewSubtitle:
      "Überwachen Sie die Netzwerkgesundheit, beantworten Sie Bewertungen und verwalten Sie Löschfälle von einem Ort.",
    planLabel: "Tarif",
    billingLink: "Pläne & Abrechnung",
    activeCasesLabel: "Aktive Fälle",
    activeCasesHint: "Löschanträge in Bearbeitung",
    sentimentSnapshot: "Stimmungsübersicht",
    positive: "Positiv",
    neutral: "Neutral",
    negative: "Negativ",
    connectForSentiment: "Verbinden Sie ein Profil, um die Stimmungsverteilung zu sehen.",
    recommendedWorkflow: "Empfohlener Workflow",
    workflow1: "Review Hub → Kritisch für dringende Bewertungen",
    workflow2: "Antworten oder Entfernung direkt in der Bewertungskarte",
    workflow3: "Fortschritt der Entfernung unter Löschfälle verfolgen",
    defamationGuide: "Leitfaden Verleumdung",
    defamationGuideDesc:
      "Erfahren Sie, wann eine Bewertung für eine rechtliche Entfernung infrage kommt und wie Sie Ihren Fall dokumentieren.",
    readDocumentation: "Dokumentation lesen",
  },
  reviewHub: {
    needsReply: "Antwort erforderlich",
    critical: "Kritisch",
    allReviews: "Alle Bewertungen",
    reply: "Antworten",
    cancel: "Abbrechen",
    requestRemoval: "Entfernung beantragen",
    removeFromCart: "Aus Auswahl entfernen",
    sendReply: "Antwort senden",
    noReviews: "Keine Bewertungen in dieser Ansicht.",
    loading: "Bewertungen werden geladen…",
  },
  cases: {
    title: "Löschfälle",
    subtitle: "Rechtliche Entfernungsanträge verwalten und verfolgen.",
    allStatus: "Alle Status",
    allViolations: "Alle Verstoßarten",
    searchPlaceholder: "Fall-ID, Begründung oder Verstoßart…",
    filterStatus: "Nach Status filtern",
    filterViolation: "Nach Verstoßart filtern",
    status: {
      initiated: "Eingereicht",
      started: "In Bearbeitung",
      legal_action: "Rechtsschritt",
      completed: "Abgeschlossen",
      rejected: "Abgelehnt",
      pending: "Ausstehend",
      inProgress: "In Bearbeitung",
    },
    violation: {
      spam: "Spam / Fake-Bewertung",
      conflict: "Interessenkonflikt",
      insult: "Beleidigung / Hassrede",
      falseFacts: "Falsche Tatsachenbehauptung",
      privacy: "Datenschutzverletzung",
      other: "Sonstiges",
    },
    createModal: {
      title: "Löschantrag erstellen",
      subtitle:
        "{{count}} Bewertung(en) werden in einen Fall aufgenommen. Unser Team leitet die Löschung ein und informiert Sie, sobald ein Ergebnis vorliegt.",
      violationType: "Verstoßart",
      justification: "Begründung",
      justificationPlaceholder:
        "Beschreiben Sie, warum diese Bewertungen entfernt werden sollen…",
      justificationRequired: "Bitte geben Sie eine Begründung ein.",
      optional: "optional",
      selectReview: "Bitte wählen Sie mindestens eine Bewertung aus.",
      estimatedTotal: "Geschätzte Summe",
      perReview: "pro Bewertung",
      reviews: "Bewertungen",
      submit: "Fall einreichen",
      submitting: "Wird eingereicht…",
      manualInvoicingNote:
        "Die angegebenen Löschkosten dienen lediglich der Orientierung. Berechnet werden ausschließlich erfolgreich entfernte Bewertungen. Die Rechnung erhalten Sie nach Abschluss der Löschungen gesondert per E-Mail.",
      freeIncluded: "{{count}} Bewertungslöschung(en) in diesem Fall kostenlos enthalten",
      freeIncludedDetail:
        "Ihr Professional-Tarif umfasst 2 kostenlose Löschungen alle 30 Tage. Diese werden automatisch auf die ersten Bewertungen dieser Einreichung angewendet.",
      includedFree: "Inklusive",
      freeLine: "{{count}} Bewertung(en) — kostenlos inklusive",
      paidLine: "{{count}} Bewertung(en) × {{price}} (geschätzt)",
      anonymous: "Anonym",
      noText: "Kein Text",
    },
    activeConnections: "Aktive Verbindungen",
    activeConnection: "Aktive Verbindung",
    loadingCases: "Löschfälle werden geladen…",
    noCasesFilter: "Keine Fälle entsprechen diesen Filtern",
    noCasesYet: "Noch keine Löschfälle",
    noCasesFilterHint: "Passen Sie Status, Verstoßart oder Suche an.",
    noCasesYetHint:
      "Wählen Sie eine oder mehrere Bewertungen und reichen Sie einen Löschantrag ein.",
    goToReviews: "Zu Bewertungen",
    newCase: "Neuer Fall",
    violationLabel: "Verstoßart",
    justificationLabel: "Begründung",
    downloadReport: "Bericht",
    showDetails: "Details",
    hideDetails: "Ausblenden",
    statusResolved: "Abgeschlossen",
    footerCases: "{{count}} Fälle",
    privacyPolicy: "Datenschutz",
    termsOfService: "Nutzungsbedingungen",
    legalNotice: "Impressum",
    pageSubtitle:
      "Übersicht Ihrer eingereichten Löschanträge. Jeder Fall zeigt die zugehörigen Bewertungen — Details per Klick aufklappen.",
    createNewCase: "Neuen Fall erstellen",
    downloadPdf: "PDF herunterladen",
    viewDetails: "Details anzeigen",
    requestedRatings: "Angeforderte Bewertungen ({{count}})",
    submissionReason: "Begründung",
    copyright: "© 2026 ReviewLytics. Alle Rechte vorbehalten.",
    compliance: "Compliance",
    withdrawCase: "Fall zurückziehen",
    deleteModal: {
      title: "Löschfall zurückziehen?",
      subtitle:
        "Der Fall wird dauerhaft aus Ihrem Konto entfernt. Die verknüpften Bewertungen können wieder für einen neuen Löschantrag ausgewählt werden.",
      reviewCount: "{{count}} Bewertung(en) in diesem Fall",
      hint: "Nur Fälle, die noch nicht bearbeitet wurden, können zurückgezogen werden.",
      cancel: "Fall behalten",
      confirm: "Fall zurückziehen",
      deleting: "Wird zurückgezogen…",
      success: "Fall {{caseId}} wurde erfolgreich zurückgezogen.",
    },
  },
  platforms: {
    emptyTitle: "Ihr Reputations-Ökosystem ist leer",
    emptyBody:
      "Verbinden Sie Ihre erste Plattform, um Bewertungen zu überwachen, Stimmung zu analysieren und Ihren digitalen Fußabdruck zu verwalten.",
    connectPlatform: "Plattform verbinden",
    ecosystemTitle: "Plattform-Ökosystem",
    ecosystemSubtitle:
      "Steuern Sie Ihre digitale Präsenz: Verbinden Sie Google Business und Jameda und bündeln Sie Ihre Markenintelligenz.",
    connectedPlatforms: "Verbundene Plattformen",
    addPlatform: "Plattform hinzufügen",
    syncing: "Google Business wird synchronisiert…",
    oauthTitle: "Google wird verknüpft…",
    oauthDetail: "Der Server bestätigt Ihre Anmeldung bei Google.",
    accountsTitle: "Google-Konten werden geladen…",
    accountsDetail: "Antwort vom Server wird verarbeitet.",
    locationsTitle: "Standorte werden geladen…",
    locationsDetail: "Konto {{index}} von {{total}} — Antwort vom Server.",
    disconnecting: "Verbindung wird getrennt…",
    disconnectingDetail: "Die Plattform wird von Ihrem Konto entfernt.",
    architectIntelligence: "ARCHITECT INTELLIGENCE PLATFORM",
    activeConnection: "AKTIVE VERBINDUNG",
    activeConnections: "AKTIVE VERBINDUNGEN",
    manage: "Verwalten",
    disconnect: "Verbindung trennen",
    addPlatformHint:
      "Hier nur Quellen, die Sie noch nicht verbunden haben. Weitere Google-Standorte fügen Sie über das Menü (⋮) bei einer bestehenden Verbindung hinzu.",
    connectAria: "{{name}} verbinden",
    ecosystemStatus: "Ökosystem-Status",
    healthPartial:
      "Verbinden Sie beide Kanäle, um eine vollständige Sicht auf Ihre Reputation zu erhalten.",
    healthOptimal:
      "Ihre Plattform-Synchronisation ist nahezu optimal — alle konfigurierten Quellen sind aktiv.",
    upcomingSyncs: "Anstehende Synchronisierungen",
    metadataReconcile: "Metadaten-Abgleich",
    syncCadence: "alle 6 Std.",
    locationOrdinal: "Standort {{index}} von {{total}}",
    profileOrdinal: "Profil {{index}} von {{total}}",
    active: "Aktiv",
    lastSynced: "Zuletzt synchronisiert {{time}}",
    apiOk: "API-Verbindung in Ordnung",
    addAnotherGoogle: "Weiteren Standort verbinden",
    addAnotherJameda: "Jameda-Zugangsdaten aktualisieren",
    addAnotherKununu: "Weiteres Kununu-Profil verbinden",
    waitServer: "Bitte warten Sie auf die Server-Antwort.",
    relativeJustNow: "gerade eben",
    relativeMinutes: "vor {{count}} Min.",
    relativeHours: "vor {{count}} Std.",
    relativeDays: "vor {{count}} Tag",
    relativeDaysPlural: "vor {{count}} Tagen",
    googleDesc:
      "Verbinden Sie Ihr Google Business-Profil, um Bewertungen und die lokale Suchleistung direkt in Ihr Dashboard zu synchronisieren.",
    googleBadge: "BEREIT ZUR SYNCHRONISATION",
    jamedaDesc:
      "Verbinden Sie Ihr Jameda-Profil per API-Schlüssel und synchronisieren Sie Patientenbewertungen direkt in Ihr Dashboard.",
    jamedaBadge: "PATIENTENBEWERTUNGEN",
    kununuDesc:
      "Überwachen Sie die Mitarbeiterstimmung und den Markenruf auf Europas führender Arbeitgeberplattform.",
    kununuBadge: "EMPLOYER BRANDING",
    errorNoAccounts:
      "Google ist verbunden, aber es wurden keine Business-Konten oder Standorte gefunden.",
    errorLoadFailed: "Google Business konnte nicht geladen werden.",
    errorOAuthIncomplete:
      "Google-Verbindung konnte nicht abgeschlossen werden. Bitte erneut verbinden.",
    errorSaveFailed:
      "Google-Verbindung konnte nicht gespeichert werden. Bitte erneut versuchen.",
    errorOAuthFailed: "Google-Verbindung ist fehlgeschlagen. Bitte erneut verbinden.",
    errorBackend:
      "Google Business Verbindung fehlgeschlagen. Prüfen Sie Ihre Backend-Routen.",
  },
  connectPlatform: {
    title: "Plattform verbinden",
    subtitle:
      "Wählen Sie einen Reputationskanal, um mit der Synchronisierung Ihrer Markendaten zu beginnen.",
    connect: "Plattform verbinden",
    close: "Schließen",
  },
  account: {
    trial: "Testphase",
    basic: "Basic",
    premium: "Premium",
    expired: "Abgelaufen",
    // Legacy keys kept for safety
    paid: "Premium",
    unpaid: "Testphase",
  },
  plans: {
    trialBanner:
      "Ihre kostenlose Testphase endet am {{date}} um {{time}}. Wählen Sie einen Tarif, um vollen Zugriff zu behalten.",
    trialEndsToday:
      "Ihre kostenlose Testphase endet heute um {{time}}. Wählen Sie einen Tarif, um vollen Zugriff zu behalten.",
    expiredBanner:
      "Ihre kostenlose Testphase ist abgelaufen. Wählen Sie einen Tarif, um ReviewLytics weiter zu nutzen.",
    choosePlan: "Tarif wählen",
  },
  support: {
    title: "Support",
    subtitle: "Hilfe von unserem Reputations-Management-Team.",
    submitRequest: "Anfrage senden",
    subject: "Betreff",
    message: "Nachricht",
    subjectPlaceholder: "Kurze Zusammenfassung",
    messagePlaceholder: "Beschreiben Sie Ihr Anliegen…",
    send: "Senden",
    sent: "Anfrage gesendet",
    faqTitle: "Häufige Fragen",
    faq1q: "Wie funktionieren Löschfälle?",
    faq1a:
      "Wählen Sie Bewertungen auf der Bewertungsseite, reichen Sie einen Fall mit Verstoßart und Begründung ein. Unser Team prüft und leitet die rechtliche Entfernung ein.",
    faq2q: "Wann erscheint meine Antwort bei Google?",
    faq2a:
      "Antworten werden in die Warteschlange gestellt und an Google Business gesendet. Die öffentliche Anzeige kann einige Minuten dauern.",
    faq3q: "Kann ich meinen Tarif während des Abrechnungszeitraums upgraden?",
    faq3a:
      "Ja. Unter Pläne & Abrechnung können Sie auf Professional upgraden und monatliche Löschungen freischalten.",
    yourTickets: "Ihre Anfragen",
    noTickets: "Noch keine Support-Anfragen.",
    statusOpen: "Offen",
    prioritySupport: "Prioritäts-Support",
    prioritySupportHint:
      "Professional-Tarif-Abonnenten erhalten Prioritätsantwort innerhalb von 24 Stunden.",
    submitTicket: "Ticket senden",
    ticketSubmitted: "Ticket gesendet",
    statusAnswered: "Beantwortet",
    statusClosed: "Geschlossen",
    you: "Sie",
    supportTeam: "Support-Team",
    replyPlaceholder: "Antwort schreiben…",
    replySend: "Antwort senden",
    loadError: "Ihre Anfragen konnten nicht geladen werden. Bitte erneut versuchen.",
    submitError: "Ihre Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
  },
  adminSupport: {
    navTitle: "Support-Tickets",
    title: "Support-Tickets",
    subtitle: "Anfragen Ihrer Kunden — antworten und Status verwalten.",
    eyebrow: "Kunden-Support",
    filterAll: "Alle",
    searchPlaceholder: "Betreff, Name oder E-Mail suchen…",
    submittedBy: "Eingereicht von",
    replyPlaceholder: "Antwort an den Kunden schreiben…",
    replySend: "Antwort senden",
    close: "Ticket schließen",
    reopen: "Wieder öffnen",
    noTickets: "Keine Tickets gefunden.",
    loadError: "Tickets konnten nicht geladen werden. Bitte erneut versuchen.",
    openCount: "{{count}} offen",
  },
  onboarding: {
    stepOf: "Schritt {{current}} von {{total}}",
    welcomeTitle: "Willkommen bei ReviewLytics",
    welcomeDesc:
      "Richten Sie Ihren Arbeitsbereich in wenigen Schritten ein. Verbinden Sie Ihr Profil, synchronisieren Sie Bewertungen und starten Sie.",
    connectTitle: "Google Business verbinden",
    connectDesc:
      "Verknüpfen Sie Ihr Google Business-Profil, um Bewertungen, Ratings und Antworten zu importieren.",
    syncTitle: "Bewertungen synchronisieren",
    syncDesc:
      "Nach der Verbindung werden Bewertungen automatisch synchronisiert. Manuelle Synchronisation ist auf der Bewertungsseite möglich.",
    exploreTitle: "Sie sind startklar",
    exploreDesc:
      "Nutzen Sie Dashboard, Review Hub und Kritische Bewertungen, um zu antworten und Ihre Reputation zu schützen.",
    skip: "Überspringen",
    next: "Weiter",
    finish: "Zum Dashboard",
    connectNow: "Jetzt verbinden",
    connected: "Verbunden",
    locationsConnected: "{{count}} Standort(e) verbunden",
    notConnectedYet: "Noch nicht verbunden",
    goToPlatforms: "Zu Plattformen",
    syncConnected:
      "Ihr Profil ist verbunden. Bewertungen erscheinen nach der Synchronisation im Posteingang.",
    syncNotConnected:
      "Verbinden Sie zuerst eine Plattform und kehren Sie dann hierher zurück.",
    skipForNow: "Jetzt überspringen",
    continue: "Weiter",
    back: "Zurück",
  },
  documentation: {
    title: "Dokumentation",
    subtitle: "Leitfäden und Referenzen für Ihren Reputations-Arbeitsbereich.",
  },
  impersonation: {
    actingAs:
      "Sie agieren als {{target}} ({{email}}). Ursprüngliche Admin-Sitzung: {{admin}}.",
    ending: "Beende…",
    backToAdmin: "Zurück zum Admin",
  },
  platformBenefits: {
    eyebrow: "Ihre Vorteile mit ReviewLytics",
    dashboardTitle: "Ihre Reputations-Vorteile",
    dashboardSubtitle:
      "Diese Funktionen arbeiten im Hintergrund — damit Sie Risiken früher sehen und Vertrauen schneller aufbauen.",
    dismiss: "Ausblenden",
    customAlertsTitle: "Custom Alerts",
    customAlertsBody:
      "Sofortige Benachrichtigungen bei neuen negativen Bewertungen — damit Sie reagieren, bevor Schaden entsteht.",
    sentimentTitle: "Sentiment Analysis",
    sentimentBody:
      "Automatische Analyse der Stimmung und häufigsten Kritikpunkte in Bewertungen.",
    localSeoTitle: "Lokales SEO stärken",
    localSeoBody:
      "Verbesserung des lokalen SEO durch kontinuierlich neue positive Bewertungen und aktive Beantwortung von Rezensionen.",
  },
  admin: {
    usersTitle: "Benutzer",
    usersSubtitle: "Konten und Rollen verwalten.",
    role: "Rolle",
    account: "Konto",
    searchPlaceholder: "Name, E-Mail, Unternehmen…",
    filterRole: "Rolle filtern",
    filterAccount: "Kontostatus filtern",
    loadingUsers: "Lade Benutzer…",
    totalUsers: "{{count}} Benutzer gesamt",
    pageOf: "Seite {{page}} von {{total}}",
    administrator: "Administrator",
    userRole: "Benutzer",
    roleUser: "Benutzer (Kunde)",
    roleAdmin: "Administrator",
    openClientProfile: "Kundenprofil öffnen",
    loginAsAdmin: "Als Admin anmelden",
    loggingIn: "Anmelden…",
  },
  placeholder: {
    comingSoon: "Diese Seite wird in Kürze verfügbar sein.",
    title: "{{title}}",
  },
};

export default de;
